import React from 'react';

import {V2RequestsFeature} from 'auth/capabilities/CapabilityFeatureConstants';
import {isFeatureEnabled} from 'auth/feature-enablement/FeatureStatus';
import BenchlingConfig from 'BenchlingConfig';
import makeCustomButtonActionFunction from 'notebook/structured-tables/action-functions/makeCustomButtonActionFunction';
import unsupportedOverflowMenuItem from 'notebook/structured-tables/action-functions/unsupportedOverflowMenuItem';
import {ActionFunctionParameters} from 'notebook/structured-tables/StructuredTableConstants';
import CreateRequestV2SubmissionShortcutButton from 'processes/requests_v2/shortcuts/CreateRequestV2SubmissionShortcutButton';

function renderToolbarButton<TTableMetadata, TRowMetadata>({
  structuredTable,
  structuredTableAdapter,
  computedTable,
}: ActionFunctionParameters<TTableMetadata, TRowMetadata>): JSX.Element {
  return (
    <CreateRequestV2SubmissionShortcutButton
      structuredTable={structuredTable}
      structuredTableAdapter={structuredTableAdapter}
      computedTable={computedTable}
    />
  );
}

export const createRequestV2SubmissionActionFunction = makeCustomButtonActionFunction({
  renderToolbarButton,
  renderOverflowMenuItem: unsupportedOverflowMenuItem,
  getHidden: () =>
    !BenchlingConfig.REQUESTS_V2_ENABLE || !isFeatureEnabled({feature: V2RequestsFeature.V2_REQUESTS_CREATE}),
});
